// src/App.tsx
import './App.css';
import './i18n';
import AppRouter from './router/AppRouter';
import { GridBackgroundLayout } from '@components/layout/GridBackgroundLayout';
import { AppToastContainer } from '@components/ui/AppToastContainer/AppToastContainer';
import { AppOfflineOverlay } from '@components/ui/AppOfflineOverlay/AppOfflineOverlay';
import { AnalyticsConsentControls } from '@components/analytics/AnalyticsConsentControls';
import { AnalyticsConsentProvider } from '@context/AnalyticsConsentContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AnalyticsConsentProvider>
        <GridBackgroundLayout disableOnMobile>
          <AppRouter />
        </GridBackgroundLayout>
        <AnalyticsConsentControls />
        <AppToastContainer />
        <AppOfflineOverlay />
      </AnalyticsConsentProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
